<template>
    <form ref="form" class="needs-validations">
        <p v-if="message" class="alert alert-success" v-html="message"></p>
        <p v-else-if="error" class="alert alert-danger" v-html="error"></p>
        <p v-else>
        </p>
        <fieldset>
            <legend class="sr-only">Contact us</legend>
            <div class="row">
                <template v-for="field in _.get(config, 'fields', [])">
                    <div v-if="field.data_type == 'input-text'"
                        :key="field.name"
                        :class="[twoColumns ? 'col-sm-6' : 'col-12']">
                        <div class="form-group">
                            <label :for="field.name" class="">{{ field.title }}</label>
                            <input v-model="formData[field.name]"
                                   :id="field.name"
                                   :name="field.name"
                                   :_placeholder="field.title"
                                   :required="field.required"
                                   :class="['form-control', 'req', getFieldError(field.name) ? 'is-invalid' : '']"
                                   type="text"
                                   tabindex="1">
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-email'"
                        :key="field.name"
                        :class="[twoColumns ? 'col-sm-6' : 'col-12']">
                        <div class="form-group">
                            <label :for="field.name" class="">{{ field.title }}</label>
                            <input v-model="formData[field.name]"
                                   :id="field.name"
                                   :name="field.name"
                                   :_placeholder="field.title"
                                   :required="field.required"
                                   :class="['form-control', 'req', getFieldError(field.name) ? 'is-invalid' : '']"
                                   type="text"
                                   tabindex="1">
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-number'"
                        :key="field.name"
                        :class="[twoColumns ? 'col-sm-6' : 'col-12']">
                        <div class="form-group">
                            <label :for="field.name" class="">{{ field.title }}</label>
                            <input v-model="formData[field.name]"
                                   :id="field.name"
                                   :name="field.name"
                                   :_placeholder="field.title"
                                   :required="field.required"
                                   :class="['form-control', 'req', getFieldError(field.name) ? 'is-invalid' : '']"
                                   type="number"
                                   tabindex="1">
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'input-phone'"
                        :key="field.name"
                        :class="[twoColumns ? 'col-sm-6' : 'col-12']">
                        <div class="form-group">
                            <label :for="field.name" class="">{{ field.title }}</label>
                            <input v-model="formData[field.name]"
                                   :id="field.name"
                                   :name="field.name"
                                   :_placeholder="field.title"
                                   :required="field.required"
                                   :class="['form-control', 'req', getFieldError(field.name) ? 'is-invalid' : '']"
                                   type="tel"
                                   tabindex="1">
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'file-upload'"
                        :key="field.name"
                        :class="['col-12']">
                        <div class="form-group">
                            <label :for="field.name" class="">{{ field.title }}</label>
                            <input v-on:change="(e) => handleFileInput(field.name, e)"
                                   :id="field.name"
                                   :name="field.name"
                                   :_placeholder="field.title"
                                   :required="field.required"
                                   :class="['form-control', 'req', getFieldError(field.name) ? 'is-invalid' : '']"
                                   type="file"
                                   tabindex="1">
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'selectbox'" :class="[twoColumns ? 'col-sm-6' : 'col-12']">
                        <div class="form-group">
                            <select v-model="formData[field.name]"
                                    :id="field.name"
                                    :name="field.name"
                                    :_placeholder="field.title"
                                    :required="field.required"
                                    :data-title="field.title"
                                    data-width="100%"
                                    data-size="8"
                                    data-style="btn-select"
                                    class="selectpicker"
                                    tabindex="1">
                                <option v-for="option in field.values" :value="option">{{ option }}</option>
                            </select>
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="field.data_type == 'textarea'" class="col-12">
                        <div class="form-group">
                            <label :for="field.name">{{ field.title }}</label>
                            <textarea v-model="formData[field.name]"
                                :name="field.name"
                                :id="field.name"
                                :_placeholder="field.title"
                                :required="field.required"
                                :class="['form-control', getFieldError(field.name) ? 'is-invalid' : '']"
                                rows="8"
                                tabindex="1"
                                ></textarea>
                            <div :class="[getFieldError(field.name) ? 'invalid-feedback' : '']">
                                {{ getFieldError(field.name) }}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </fieldset>

        <div class="form-group mb-0">
            <button disabled
                :class="[
                    'btn',
                    'btn-outline-primary',
                    'btn-lg',
                    'btn-inline-block',
                    'rounded-0',
                    'text-uppercase',
                    'disabled',
                    loading ? '' : 'd-none'
                ]"
                >Please wait...</button>
            <button ref="form-btn"
                :data-sitekey="recaptcha"
                :class="[
                    'btn',
                    'btn-outline-primary',
                    'btn-lg',
                    'btn-inline-block',
                    'rounded-0',
                    'text-uppercase',
                    loading ? 'd-none' : ''
                ]"
                data-theme="light"
                type="button"
                tabindex="4"
                >Submit</button>
        </div>
    </form>
</template>

<script>
import UtilsMixin from './UtilsMixin';
import FormMixin from '72cms-orm/components/FormValidationMixin';

export default{
    data() {
        return {
            loading: false,
            recaptcha: window.env.GOOGLE_RECAPTCHA_KEY,
        }
    },

    component: {

    },

    mixins: [
        UtilsMixin,
        FormMixin,
    ],

    created() {

    },

    mounted() {
        this.$nextTick(() => {
            this.initSubmitButton();
        })
    },

    computed: {
        twoColumns() {
            return _.get(this.config, 'twoColumns', false);
        },
    },

    methods: {
        initSubmitButton() {

        },

        handleFileInput(fname, e) {
            let file = _.get(e, 'target.files[0]');
            _.set(this.formData, fname, file);
        },
    },
}
</script>

<style scoped>

</style>
